String.prototype.replacePlaceholders = function (replacements) {

    // Use a regular expression to find placeholders like ":name"
    const regex = /:([a-zA-Z_]+)/g;

    // Replace each placeholder with the corresponding value from the replacements object
    const replacedString = this.replace(regex, (match, placeholder) => {

        if (replacements.hasOwnProperty(placeholder)) {
            return replacements[placeholder];
        } else {
            return match; // If no replacement is found, keep the placeholder as is
        }

    });

    return replacedString;
};

Object.size = function (obj) {
    var size = 0,
        key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};